import React from 'react';

import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const LeadTableHeader = ({
  searchQuery,
  onSearchChange,
  sortBy,
  onSortChange,
  selectedStatus,
  onStatusChange,
  selectedAssignee,
  onAssigneeChange,
  onBulkAction,
  selectedLeads,
  selectedCount,
  totalLeads,
  isBulkMode,
  onToggleBulkMode,
  onAddLead,
  onSendCampaign
}) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'new', label: 'New' },
    { value: 'contacted', label: 'Contacted' },
    { value: 'qualified', label: 'Qualified' },
    { value: 'proposal', label: 'Proposal' },
    { value: 'negotiation', label: 'Negotiation' },
    { value: 'closed-won', label: 'Closed Won' },
    { value: 'closed-lost', label: 'Closed Lost' }
  ];

  const sortOptions = [
    { value: 'name', label: 'Name' },
    { value: 'score', label: 'Lead Score' },
    { value: 'created', label: 'Date Created' },
    { value: 'updated', label: 'Last Updated' },
    { value: 'company', label: 'Company' }
  ];

  const count = selectedLeads?.length ?? selectedCount ?? 0;

  return (
    <div className="p-6 border-b border-border">
      {/* Header Row */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-4 gap-3">
        <div className="flex items-center space-x-3">
          <span className="text-sm text-muted-foreground">{totalLeads || 0} total leads</span>
          {count > 0 && (
            <span className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs font-medium rounded-full">
              {count} selected
            </span>
          )}
        </div>
        <div className="flex items-center space-x-2">
          <button
            onClick={onToggleBulkMode}
            className={`flex items-center space-x-1.5 px-3 py-2 rounded-lg text-sm font-medium border transition-colors ${
              isBulkMode
                ? 'bg-orange-100 border-orange-300 text-orange-700' :'bg-muted border-border text-muted-foreground hover:bg-muted/80'
            }`}
          >
            <Icon name="CheckSquare" size={15} />
            <span>{isBulkMode ? 'Exit Bulk' : 'Bulk Mode'}</span>
          </button>
          <button
            onClick={onAddLead}
            className="flex items-center space-x-1.5 px-3 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors"
          >
            <Icon name="UserPlus" size={15} />
            <span>Add Lead</span>
          </button>
          <button
            onClick={onSendCampaign}
            className="flex items-center space-x-1.5 px-3 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
          >
            <Icon name="Send" size={15} />
            <span>Send Campaign</span>
          </button>
        </div>
      </div>

      {/* Filters Row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <Input
          type="search"
          placeholder="Search leads..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="w-full"
        />
        <Select
          placeholder="Filter by status"
          options={statusOptions}
          value={selectedStatus}
          onChange={onStatusChange}
        />
        <Select
          placeholder="Sort by"
          options={sortOptions}
          value={sortBy}
          onChange={onSortChange}
        />
        {count > 0 && (
          <div className="flex items-center space-x-2">
            <button
              onClick={() => onBulkAction?.('send-campaign')}
              className="flex-1 flex items-center justify-center space-x-1 px-3 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
            >
              <Icon name="Send" size={14} />
              <span>Campaign</span>
            </button>
            <button
              onClick={() => onBulkAction?.('export')}
              className="flex-1 flex items-center justify-center space-x-1 px-3 py-2 border border-border bg-muted text-foreground rounded-lg text-sm font-medium hover:bg-muted/80 transition-colors"
            >
              <Icon name="Download" size={14} />
              <span>Export</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeadTableHeader;